import React from 'react';
import OnDemandTrainingsMain from '../training/on-demand-training/OnDemandTrainingsMain';
import {
  TrainingOptionsModule,
  TrainingOptionsOptionFields,
} from '../training/on-demand-training/Types';

interface OnDemandTrainingsProps {
  module: {
    fields?: TrainingOptionsModule;
  };
}

const OnDemandTrainings: React.FC<OnDemandTrainingsProps> = ({ module }) => {
  const fields: TrainingOptionsOptionFields | undefined =
    module.fields?.options?.[0]?.fields;
  if (!fields) {
    return null;
  }
  return <OnDemandTrainingsMain fields={fields} />;
};

export default OnDemandTrainings;
